import React, { useContext, useEffect, useState } from "react";
import Rtocal from "../../../src/assets/images/RTO-Calender.svg";
import Rtosec from "../../../src/assets/images/RTO-Security.svg";
import Rtotot from "../../../src/assets/images/RTO-Total.svg";
import { axInstBasic } from "../Service/Service";
import { FilterContext } from "../../context/Filter";

const fetchTotalVehicles = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}totalVehicles`,
      { parArn, childArn }
    );
    return res.data?.result;
  } catch (error) {
    console.error(`API fetch error (${"totalVehicles"}):`, error);
    return null;
  }
};

export const getArnPayload = (parArn, childArn) => {
  const base = {
    ...(childArn ? { childArn } : { parArn }),
  };

  Object.keys(base).forEach((key) => {
    if (Array.isArray(base[key]) && base[key].length === 0) {
      delete base[key];
    }
  });
  return base;
};

export const getInactivePermit = async (parArn, childArn) => {
  const values = getArnPayload(parArn, childArn);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}inactivePermit`,
      values
    );
    return res?.data || null;
  } catch (error) {
    console.error("Error fetching currentPipeline:", error);
    throw error;
  }
};
export const getInactiveInsurance = async (parArn, childArn) => {
  const values = getArnPayload(parArn, childArn);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}inactiveInsurance`,
      values
    );
    return res?.data || null;
  } catch (error) {
    console.error("Error fetching inactiveInsurance:", error);
    throw error;
  }
};
export const getLastSixMonthReg = async (parArn, childArn) => {
  const values = getArnPayload(parArn, childArn);
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}lastSixMonthReg`,
      values
    );
    return res?.data || null;
  } catch (error) {
    console.error("Error fetching lastSixMonthReg:", error);
    throw error;
  }
};

const Rtocard = () => {
  const { arn: parArn, childArn } = useContext(FilterContext);
  const [inactivePermitData, setInActivePermitData] = useState(null);
  const [inActiveInsuranceData, setInInsuranceData] = useState(null);
  const [lastSixMontData, setLastSixMonthData] = useState(null);
  const [totalVehicle, setTotalVehicle] = useState(null);

   const inactivePermit = async () => {
    try {
      const response = await getInactivePermit(parArn, childArn);
      setInActivePermitData(response);
      // console.log("Response1:", response);
    } catch (error) {
      console.error("Error fetching pipeline data:", error);
    }
  };
   const fetchTotalVehicleCount = async () => {
    try {
      const response = await fetchTotalVehicles(parArn, childArn);
      setTotalVehicle(response?.doc_count);
      // console.log("Response1:", response);
    } catch (error) {
      console.error("Error fetching pipeline data:", error);
    }
  };

  const inactiveInsurance = async () => {
    try {
      const response = await getInactiveInsurance(parArn, childArn);
      setInInsuranceData(response);
      // console.log("Response2:", response);
    } catch (error) {
      console.error("Error fetching pipeline data:", error);
    }
  };

  const lastSixMonthReg = async () => {
    try {
      const response = await getLastSixMonthReg(parArn, childArn);
      setLastSixMonthData(response);
      // console.log("Response3:", response);
    } catch (error) {
      console.error("Error fetching pipeline data:", error);
    }
  };

  useEffect(() => {
    if (parArn || childArn) inactivePermit();
    if (parArn || childArn) inactiveInsurance();
    if (parArn || childArn) lastSixMonthReg();
    if (parArn || childArn) fetchTotalVehicleCount();
  }, [parArn, childArn]);

  // console.log("Total Vehicle", totalVehicle)
  return (
    <div className="flex flex-col ">
      {/* Total Invoiced Vehicles */}
      <div className="flex justify-between border p-2 rounded-md m-2 items-center">
        <div className="flex items-center gap-1">
          <img src={Rtotot} alt="Total" className="w-6 h-6" />
          <h1 className="text-xs font-semibold text-gray-600">
            Total Invoiced Vehicles
          </h1>
        </div>
        <h1 className="text-xs font-semibold text-[#233D91]">{totalVehicle}</h1>
      </div>
      <div className="flex justify-between border p-2 rounded-md m-2 items-center">
        <div className="flex items-center gap-1">
          <img src={Rtocal} alt="Calendar" className="w-6 h-6" />
          <h6 className="text-xs font-semibold text-gray-600">
            Reg. In Last Six Months
          </h6>
        </div>
        <h1 className="text-xs font-semibold text-[#233D91]">
          {lastSixMontData?.total}
        </h1>
      </div>
      <div className="flex justify-between border p-2 rounded-md m-2 items-center">
        <div className="flex items-center gap-1">
          <img src={Rtocal} alt="Calendar" className="w-6 h-6" />
          <h6 className="text-xs font-semibold text-gray-600">
            Inactive Insurance
          </h6>
        </div>
        <h1 className="text-xs font-semibold text-[#233D91]">
          {inActiveInsuranceData?.total}
        </h1>
      </div>

      {/* Registration in Last 6 Months */}
      <div className="flex justify-between border p-2 rounded-md m-2 items-center">
        <div className="flex items-center gap-1">
          <img src={Rtocal} alt="Calendar" className="w-6 h-6" />
          <h6 className="text-xs font-semibold text-gray-600">
            Inactive Permit
          </h6>
        </div>
        <h1 className="text-xs font-semibold text-[#233D91]">
          {inactivePermitData?.total}
        </h1>
      </div>

      {/* ILCV and SCV & PU Section */}
      {/* <div className="flex gap-2 m-2"> */}
      {/* ILCV */}
      {/* <div className="flex border p-2 rounded-md gap-2 items-start flex-1">
          <img src={Rtosec} alt="ILCV" className="w-6 h-6 mt-1" />
          <div>
            <h1 className="text-xs font-semibold text-gray-600">ILCV</h1>
            <h6 className="text-xs">ICV Trucks</h6>
            <h6 className="text-xs">LCV</h6>
          </div>
        </div> */}

      {/* SCV & PU */}
      {/* <div className="flex border p-2 rounded-md gap-2 items-start flex-1">
          <img src={Rtosec} alt="SCV" className="w-6 h-6 mt-1" />
          <div>
            <h1 className="text-xs font-semibold text-gray-600">SCV & PU</h1>
            <h6 className="text-xs">Pickup</h6>
            <h6 className="text-xs">SCV Cargo</h6>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Rtocard;
